import Badge from "components/common/Badge";


const Store = () => {


    return (
       <>
        <Badge text="실패" type='solid' color='red'></Badge>
          <Badge text="D-34" type='soft' color='purple'></Badge></>
         

    );
};

export default Store;

